import React from 'react';
import { StyleSheet, View } from 'react-native';
import { Button, HStack, Modal, ModalDialogue, theme } from '@sg/garnish';

import { useLocalizationContext } from '@order/Localization';

import { useProductDetailsScreenContext } from '../../ProductDetailsScreen.provider';

// ────────────────────────────────────────────────────────────────────────────────

export const ProductModals = () => {
  return (
    <View style={styles.wrapper}>
      <NoDressingModal />
    </View>
  );
};

// ─── MODALS ─────────────────────────────────────────────────────────────────────

const NoDressingModal = () => {
  const { t } = useLocalizationContext();
  const {
    shouldShowNoDressingModal,
    continueCustomization,
    finishCustomization,
  } = useProductDetailsScreenContext();

  return (
    <ModalDialogue
      testID="pdp-modals.no-dressing"
      visible={shouldShowNoDressingModal}
      onRequestClose={continueCustomization}
      size="medium"
      headline={t('pdp.modifications.no-dressing-modal.heading')}
      body={t('pdp.modifications.no-dressing-modal.text')}
    >
      <Modal.Footer withoutTopBorder withoutBottomPadding>
        <HStack
          itemsPerRow={2}
          customSpacing={theme.spacing.medium}
          style={styles.noDressingCtaWrapper}
          shouldFillAvailableSpace={false}
        >
          <Button
            size="large"
            palette="secondary"
            onPress={continueCustomization}
            testID="pdp-modals.no-dressing.go-back"
          >
            {t('general.go-back')}
          </Button>

          <Button
            size="large"
            palette="primary"
            onPress={finishCustomization}
            testID="pdp-modals.no-dressing.continue"
          >
            {t('general.continue')}
          </Button>
        </HStack>
      </Modal.Footer>
    </ModalDialogue>
  );
};

// ─── STYLES ─────────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  wrapper: {
    flex: 0,
  },

  noDressingCtaWrapper: {
    paddingTop: theme.spacing.small,
  },
});
